module.exports = __webpack_public_path__ + "img/temp.1cc3331c.jpg";